<script>
  export let size = "w-2 h-2";
  export let color = "bg-brand";
  export let spacing = "space-x-1";
</script>

<div class="flex items-center {spacing}">
  <div class="{size} {color} rounded-full animate-bounce"></div>
  <div class="{size} {color} rounded-full animate-bounce" style="animation-delay: 0.1s;"></div>
  <div class="{size} {color} rounded-full animate-bounce" style="animation-delay: 0.2s;"></div>
</div>

<style>
  @keyframes bounce {
    0%,
    80%,
    100% {
      transform: translateY(0);
    }
    40% {
      transform: translateY(-8px);
    }
  }

  .animate-bounce {
    animation: bounce 1s infinite;
  }
</style>
